// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDE2IDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTMuMiAoNzI2NDMpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPg0KICAgIDx0aXRsZT5jaGVjay13aGl0ZTwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJjaGVjay13aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyI+DQogICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbC1vcGFjaXR5PSIwIiBmaWxsPSIjRDhEOEQ4IiBwb2ludHM9IjAgMCAxNiAwIDE2IDE2IDAgMTYiPjwvcG9seWdvbj4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNC4yLDIuODM1IEMxNC40LDIuNjIgMTQuNzMzLDIuNjEgMTQuOTQ1LDIuODExIEMxNS4xNDUsMyAxNS4xNjUsMy4zMDkgMTUuMDAyLDMuNTIzIEwxNC45NjksMy41NjMgTDYuMDQ5LDEzLjE2NSBDNS44NTksMTMuMzcgNS41NDUsMTMuMzg5IDUuMzMzLDEzLjIxNSBMNS4yOTUsMTMuMTggTDEuMDQ1LDguOTUzIEMwLjg0LDguNzQ3IDAuODM3LDguNDEgMS4wNCw4LjIgQzEuMjMzLDguMDAzIDEuNTQsNy45ODkgMS43NDgsOC4xNiBMMS43ODUsOC4xOTQgTDUuNjUsMTIuMDQgTDE0LjIsMi44MzUgWiIgaWQ9IlBhdGgiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Advanced list Template styles starts  */
/* .kore-chat-window .kore-chat-body {
	background: #FAFAFA !important;
} */
.kore-chat-window .advanced-list-wrapper {
  padding: 10px;
  background: #ffffff;
  margin: 2px 0px;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec {
  display: flex;
  align-items: center;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec .left-sec {
  width: 80%;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec .right-sec {
  width: 20%;
  text-align: right;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec .right-sec .button- {
  color: #0D6EFD;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  border: 0;
  outline: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 5px 0 0 -5px;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data .tag-name {
  background: #E7F1FF;
  border-radius: 4px;
  padding: 10px;
  color: #07377F;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 5px;
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data .more-tags {
  padding: 10px 15px;
  color: #0D6EFD;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data .more-tags img {
  margin-left: 10px;
  position: relative;
  top: 1px;
}

.kore-chat-window .advanced-list-wrapper .main-title {
  color: #202124;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper .desc-title {
  color: #9aa0a6;
  letter-spacing: 0.270833px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  margin-top: 2px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title {
  display: flex;
  align-items: center;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block {
  width: 40px;
  height: 40px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.circle-img.icon-text {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block .icon-text {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  font-size: 12px;
  border-radius: 8px;
  background: #0D6EFD;
  color: white;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.small {
  width: 16px;
  height: 16px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.small img {
  width: 16px;
  height: 16px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.small .icon-text {
  width: 16px;
  height: 16px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.medium {
  width: 60px;
  height: 60px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.medium img {
  width: 60px;
  height: 60px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.medium .icon-text {
  width: 60px;
  height: 60px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.large {
  width: 80px;
  height: 80px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.large img {
  width: 80px;
  height: 80px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.large .icon-text {
  width: 80px;
  height: 80px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.circle-img img {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.circle-img .icon-text {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block {
  padding-left: 15px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block.pd-0 {
  padding-left: 0px !important;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-text {
  color: #202124;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc {
  color: #9aa0a6;
  letter-spacing: 0.270833px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  margin-top: 2px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .content-block {
  width: 65%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .btn_block {
  width: 30%;
}

.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown {
  text-align: right !important;
  margin-right: 10px;
  padding: 0 !important;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .btn_block .amout-text {
  text-align: right;
  color: #202124;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .btn_block .button_ {
  float: right;
  border: 0;
  padding: 7px 20px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #020203;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows {
  flex-wrap: wrap;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .main-title-text {
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: #202124;
  margin-bottom: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .rows-multiple-list {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #E4E5E7;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data {
  display: block;
  width: 100%;
  text-align: right;
  padding: 15px 0 8px 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data span {
  cursor: pointer;
  color: #0D6EFD;
  margin: 0px 6px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data .button_ {
  border: 0;
  padding: 7px 10px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 3px 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data .button_ img {
  position: relative;
  top: 1px;
  margin-left: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data span img {
  position: relative;
  top: 1px;
  margin-left: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion {
  display: block;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  position: relative;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .title-main {
  color: #202124;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  width: 70%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .title-main.w-100 {
  width: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .filter-sort-block {
  display: flex;
  align-items: center;
  width: 30%;
  justify-content: flex-end;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .filter-sort-block .filter-icon {
  margin-left: 10px;
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .filter-sort-block .sort-icon {
  margin-left: 10px;
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block {
  width: 30%;
  text-align: right;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block .search_icon {
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block .input_text {
  position: absolute;
  background-color: #fff;
  border: solid 1px #BDC1C6;
  border-radius: 4px;
  height: 34px;
  padding: 10px 30px 10px 10px;
  font-size: 14px;
  color: #202124;
  line-height: normal;
  margin: 0 !important;
  outline: 0 !important;
  right: -10px;
  width: 200px;
  top: -6px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block .close_icon {
  position: absolute;
  right: 0;
  cursor: pointer;
  top: 5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .if-button-mode {
  width: 30%;
  text-align: right;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .if-button-mode .button- {
  color: #0D6EFD;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  border: 0;
  outline: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.kore-chat-window .advanced-list-wrapper .small-title-sec {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  box-shadow: inset 0px -1px 0px #eff0f1;
}

.kore-chat-window .advanced-list-wrapper .small-title-sec .left-title {
  width: 80%;
  color: #9AA0A6;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
}

.kore-chat-window .advanced-list-wrapper .small-title-sec .right-title {
  width: 20%;
  text-align: right;
  color: #9AA0A6;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs .month-tab {
  color: #202124;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-right: 40px;
  padding-bottom: 10px;
  cursor: pointer;
  transition: 0.3s all ease;
  position: relative;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs .month-tab:hover::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: #0D6EFD;
  bottom: 0;
  left: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs .month-tab.active-month::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: #0D6EFD;
  bottom: 0;
  left: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block {
  width: 30%;
  padding-right: 18px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .amout-text {
  text-align: right;
  color: #202124;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .button_ {
  float: right;
  border: 0;
  padding: 7px 20px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  word-break: normal;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag {
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  float: right;
  padding: 2px 14px;
  font-weight: normal;
  font-size: 10px;
  line-height: 17px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag.confirm {
  background: #E7F1FF;
  color: #2F80ED;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag.shorlisted {
  color: #27AE60;
  background: #EAF6EC;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag.hold {
  background: #FFF1ED;
  color: #EB5757;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .action-icon-acc {
  position: absolute;
  right: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .action-icon-acc.rotate-icon {
  transform: rotate(180deg);
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content {
  padding-top: 14px;
  display: none;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .button-header {
  font-size: 12px;
  color: #5F6368;
  border-top: 1px solid #E4E5E7;
  margin-top: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .button-header .button-header-title {
  margin-top: 5px;
  margin-left: 5px;
  font-weight: 500;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content {
  display: flex;
  align-items: flex-start;
  margin: 5px 0;
  padding: 5px 10px 0 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content .icon-img {
  width: 25px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content .icon-img img {
  vertical-align: middle;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content .text-info {
  padding-left: 0;
  color: #5f6368 !important;
  letter-spacing: 0.3px;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc {
  display: flex;
  align-items: center;
  margin: 10px -5px 0 -5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-center {
  justify-content: center;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-center .button_ {
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-left {
  justify-content: start;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-left .button_ {
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-right {
  justify-content: flex-end;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-right .button_ {
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-full-width-btn {
  flex-wrap: wrap;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  position: relative;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-full-width-btn .button_ {
  width: 100%;
}

/* .kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info{
    list-style: none;
    display: none;
    position: absolute;
    padding: 10px;
    right: 10px;
    max-height: 200px;
    box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
    border-radius: 5px;
    background: #fff;
    height: auto;
    min-height: auto;
    z-index: 99;
} */
.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info li {
  margin: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info li .button_ {
  margin: 5px 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ {
  border: 0;
  padding: 7px 10px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 3px 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .more-btn {
  border: 0;
  padding: 7px 10px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 3px 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info .close_btn {
  cursor: pointer;
  border: none;
  outline: none;
  position: static !important;
  /* top: 5px; */
  right: 22px;
  background: #fff;
  border-radius: 100%;
  padding: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  z-index: 2;
  transition: 0.3s all ease;
  float: right;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info .close_btn:hover {
  background: #DFE7F5;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper {
  padding: 10px;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px #eff0f1;
  margin: 2px 0px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper .main-title {
  color: #202124;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper .desc-title {
  color: #9aa0a6;
  letter-spacing: 0.270833px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  margin-top: 2px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title {
  display: flex;
  align-items: center;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block {
  width: 40px;
  height: 40px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block .icon-text {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block.circle-img img {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block.circle-img .icon-text {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .content-block {
  padding-left: 15px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .content-block .title-text {
  color: #202124;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .content-block .title-desc {
  color: #9aa0a6;
  letter-spacing: 0.270833px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  margin-top: 2px;
  word-break: break-word;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .content-block {
  width: 65%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .btn_block {
  width: 30%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .btn_block .amout-text {
  text-align: right;
  color: #202124;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .btn_block .button_ {
  float: right;
  border: 0;
  padding: 7px 20px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ img {
  margin-right: 6px;
  vertical-align: middle;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .more-btn img {
  margin-right: 6px;
  vertical-align: middle;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec {
  padding-left: 50px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec {
  display: flex;
  flex-wrap: wrap;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table {
  width: 33%;
  margin-bottom: 15px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table-more {
  display: block;
  width: 100%;
  text-align: right;
  padding: 10px 0 8px 0;
  margin-right: 30px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table-more span img {
  position: relative;
  top: 1px;
  margin-left: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table-more span {
  cursor: pointer;
  color: #0D6EFD;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table .header-name {
  color: #9AA0A6;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 4px 0px;
  padding: 0 5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table .title-name {
  color: #202124;
  letter-spacing: 0.270833px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  margin: 4px 0px;
  padding: 0 5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns {
  margin: 0 -10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table.full-row {
  width: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table {
  width: 50%;
  margin-bottom: 15px;
  padding: 0 10px;
  display: flex;
  align-items: center;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.rounded-img {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.rounded-img img {
  border-radius: 100%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block {
  width: 30px;
  height: 30px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block img {
  width: 30px;
  height: 30px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.small {
  width: 16px;
  height: 16px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.small img {
  width: 16px;
  height: 16px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.medium {
  width: 40px;
  height: 40px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.medium img {
  width: 40px;
  height: 40px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.large {
  width: 60px;
  height: 60px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.large img {
  width: 60px;
  height: 60px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.extralarge {
  width: 80px;
  height: 80px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.extralarge img {
  width: 80px;
  height: 80px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .label-content {
  padding-left: 15px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group {
  display: flex;
  align-items: center;
  margin: 10px -5px 0 -5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group .p-button {
  border: 0;
  padding: 7px 20px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  background: #0D6EFD;
  border-radius: 4px;
  color: #FFFFFF;
  width: 100%;
  margin: 0 5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group .s-button {
  padding: 7px 20px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 0 5px;
  background: #FFFFFF;
  border: 1px solid #BDC1C6;
  box-sizing: border-box;
  border-radius: 4px;
  color: #202124;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-center {
  justify-content: center;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-center button {
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-left {
  justify-content: start;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-left button {
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-right {
  justify-content: flex-end;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-right button {
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-full-width-btn {
  flex-wrap: wrap;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-full-width-btn button {
  width: 100%;
  margin-top: 5px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows {
  margin: 8px 0 0 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #E4E5E7;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows :last-child {
  border-bottom: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data {
  display: block;
  width: 100%;
  text-align: right;
  padding: 15px 0 8px 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data .button_seemore {
  border: 0;
  padding: 7px 10px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 3px 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data .button_ img {
  position: relative;
  top: 1px;
  margin-left: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data span {
  cursor: pointer;
  color: #0D6EFD;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data span img {
  position: relative;
  top: 1px;
  margin-left: 10px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .accor-header-top .content-block {
  width: 65%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .accor-header-top .action-icon-acc.rotate-icon {
  transform: rotate(90deg);
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox {
  display: block;
  padding: 11px 10px;
  position: relative;
  border-radius: 4px;
  margin: 4px 0px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox.selected-item {
  background: #E7F1FF;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox.selected-item .checkbox-custom + .checkbox-custom-label {
  color: #202124;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  margin: 0;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom + .checkbox-custom-label {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  margin: 0;
  padding-left: 32px;
  color: #9AA0A6;
  letter-spacing: 0.270833px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom + .checkbox-custom-label::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  padding: 0;
  text-align: center;
  border-radius: 2px;
  border: solid 1px #BDC1C6;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: -2px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom + .checkbox-custom-label::after {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  padding: 0;
  text-align: center;
  border-radius: 2px;
  border: solid 1px #BDC1C6;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: -2px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:checked + .checkbox-custom-label::before {
  content: "";
  background-color: #0D6EFD;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: #fff;
  font-size: 12px;
  background-size: 14px;
  background-repeat: no-repeat;
  background-position: center;
  border: solid 1px #0D6EFD;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:checked + .checkbox-custom-label::after {
  content: "";
  background-color: #0D6EFD;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: #fff;
  font-size: 12px;
  background-size: 14px;
  background-repeat: no-repeat;
  border: solid 1px #0D6EFD;
  background-position: center;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:checked:disabled + .checkbox-custom-label::before {
  background-color: #a6dce1;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:disabled + .checkbox-custom-label::before {
  border: solid 1px #BDC1C6;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:focus + .checkbox-custom-label {
  color: #0D6EFD;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:focus + .checkbox-custom-label::before {
  border: 1px solid #1372ff;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton {
  display: block;
  padding: 11px 10px;
  position: relative;
  border-radius: 4px;
  margin: 4px 0px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton.selected-item {
  background: #E7F1FF;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton.selected-item .radio-custom + .radio-custom-label {
  color: #202124;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  margin: 0;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom + .radio-custom-label {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  color: #9AA0A6;
  margin: 0;
  font-weight: normal;
  padding-left: 32px;
  letter-spacing: 0.270833px;
  font-size: 13px;
  line-height: 16px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom + .radio-custom-label::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  padding: 0;
  margin-right: 12px;
  text-align: center;
  border: solid 1px #BDC1C6;
  background-color: #fff;
  margin-top: 0;
  border-radius: 100px;
  left: 0;
  position: absolute;
  top: -2px;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked + .radio-custom-label::before {
  content: "";
  color: #fff;
  font-size: 12px;
  background-color: #0D6EFD;
  border: 1px solid #0D6EFD;
  box-shadow: inset 0 0 0 4px #fff;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked:focus + .radio-custom-label {
  color: #0D6EFD;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked:disabled + .radio-custom-label {
  color: #dde1e7;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked:disabled + .radio-custom-label::before {
  border: solid 1px #a6dce1;
  box-shadow: inset 0 0 0 4px #fff;
  background-color: #a6dce1;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:disabled + .radio-custom-label {
  color: #dde1e7;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:disabled + .radio-custom-label::before {
  border: solid 1px #a6dce1;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:focus + .radio-custom-label {
  color: #0D6EFD;
}

.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:focus + .radio-custom-label::before {
  border: 1px solid #0D6EFD;
}

/* dropdown styles*/
.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info {
  list-style: none;
  display: none;
  position: absolute;
  padding: 10px;
  right: 10px;
  max-height: 200px;
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  border-radius: 5px;
  background: #fff;
  height: auto;
  min-height: auto;
  z-index: 99;
}

.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info li {
  margin: 0;
}

.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info li .button_ {
  width: 100%;
  margin: 5px 0;
}

.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info .close_btn {
  cursor: pointer;
  border: none;
  outline: none;
  position: static !important;
  /* top: 5px; */
  right: 22px;
  background: #fff;
  border-radius: 100%;
  padding: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  z-index: 2;
  transition: 0.3s all ease;
  float: right;
}

.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info .close_btn:hover {
  background: #DFE7F5;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data.hide {
  display: none !important;
}

.kore-chat-window .advanced-list-wrapper.fromHistory {
  pointer-events: none;
}

/* slider actions */
.kore-chat-window .kore-action-sheet {
  display: block !important;
}

.kore-chat-window .kore-action-sheet .advanced-list-wrapper {
  /* height:462px; */
  overflow-y: auto;
  animation-name: fadeInBottom;
  animation-duration: 1s;
  animation-fill-mode: both;
  height: 400px !important;
  padding: 15px;
  margin-top: 30px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info .close_btn:hover {
  background: #DFE7F5;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info {
  list-style: none;
  display: none;
  position: absolute;
  padding: 10px;
  right: 10px;
  max-height: 200px;
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  border-radius: 5px;
  background: #fff;
  height: auto;
  min-height: auto;
  z-index: 99;
  width: auto;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info li {
  margin: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info li .button_ {
  margin: 5px 0;
  border: 0;
  padding: 7px 10px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 3px 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info li .button_ img {
  margin-right: 6px;
  vertical-align: middle;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info .close_btn {
  cursor: pointer;
  border: none;
  outline: none;
  position: static !important;
  /* top: 5px; */
  right: 22px;
  background: #fff;
  border-radius: 100%;
  padding: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  z-index: 2;
  transition: 0.3s all ease;
  float: right;
}

.kore-chat-window .kore-action-sheet .advanced-list-wrapper .main-title-text-block {
  margin-top: 20px !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc {
  display: flex;
  align-items: center;
  margin: 10px -5px 0 -5px;
}

.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc .button_ {
  width: auto;
  border: 0;
  padding: 7px 10px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #07377f;
  font-weight: normal;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  margin: 3px 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc.if-full-width-btn {
  flex-wrap: wrap;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding: 15px;
}

.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc .button_ img {
  margin-right: 6px;
  vertical-align: middle;
}

.kore-action-sheet .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows {
  position: relative;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top {
  align-items: flex-start;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block {
  padding-top: 3px;
  width: 57%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top {
  align-items: flex-start;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block {
  padding-top: 3px;
  width: 53%;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block .title-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block .title-desc {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .btn_block {
  width: 40%;
  padding-right: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .btn_block .amout-text {
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #9AA0A6;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type {
  pointer-events: none;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-inner-content {
  padding-top: 0px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-inner-content .details-content.if-icon-right .text-info {
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #202124;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content.if-icon-right {
  display: block;
  position: relative;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content.if-icon-right .icon-img {
  width: auto;
  position: absolute;
  right: 4px;
  top: 9px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content.if-icon-right .text-info {
  width: 100%;
  display: inline-block;
  padding-right: 10px;
  /* font-weight: normal;
     font-size: 14px;
     line-height: 20px;
     color: #202124; */
}

/* advanced list */
.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon {
  display: flex;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon .desc-icon {
  width: 25px;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon .img {
  vertical-align: middle;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon.if-icon-right {
  display: block;
  position: relative;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon.if-icon-right .desc-icon {
  width: auto;
  position: absolute;
  right: 4px;
}

.kore-chat-window .advanced-list-wrapper .preview-modal-header {
  height: 54px;
  top: 0;
  margin: -10px -10px 10px -10px;
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px;
  font-weight: normal;
  font-size: 16px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #202124;
}

.kore-chat-window .advanced-list-wrapper .preview-modal-header .advancedlist-template-close {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  position: relative;
  top: 0;
  right: 0;
  padding: 0;
}

.kore-chat-window .advanced-list-wrapper.img-with-title .content-block.w-100 {
  width: 100% !important;
}

.advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content.displayBlock {
  display: block;
}

/* advanced-list */
/* advanced list template styles ends here */`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/advancedListTemplate/advancedListTemplate.scss"],"names":[],"mappings":"AAAA,0CAAA;AAEA;;GAAA;AAIA;EACC,aAAA;EACA,mBAAA;EAEA,eAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAKA;EACC,UAAA;EACA,iBAAA;AAFD;;AAKA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAFD;;AAKA;EACC,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AAFD;;AAKA;EACC,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAFD;;AAKA;EACC,iBAAA;EACA,kBAAA;EACA,QAAA;AAFD;;AAKA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAFD;;AAKA;EACC,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAFD;;AAKA;EACC,mBAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;AAFD;;AAKA;EACC,mBAAA;AAFD;;AAKA;EACC,mBAAA;AAFD;;AAKA;EACC,kBAAA;AAFD;;AAKA;EACC,4BAAA;AAFD;;AAKA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAFD;;AAKA;EACC,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAKA;EACC,4BAAA;EACA,kBAAA;EACA,qBAAA;AAFD;;AAKA;EACC,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,YAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAFD;;AAKA;EACC,eAAA;AAFD;;AAKA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAFD;;AAKA;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAFD;;AAKA;EACC,cAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AAFD;;AAKA;EACC,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAFD;;AAKA;EACC,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAFD;;AAKA;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;AAFD;;AAKA;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;AAFD;;AAKA;EACC,cAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAFD;;AAKA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;AAFD;;AAKA;EACC,iBAAA;EACA,eAAA;AAFD;;AAKA;EACC,iBAAA;EACA,eAAA;AAFD;;AAKA;EACC,UAAA;EACA,iBAAA;AAFD;;AAKA;EACC,eAAA;AAFD;;AAKA;EACC,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;AAFD;;AAKA;EACC,kBAAA;EACA,QAAA;EACA,eAAA;EACA,QAAA;AAFD;;AAKA;EACC,UAAA;EACA,iBAAA;AAFD;;AAKA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,sCAAA;AAFD;;AAKA;EACC,UAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,UAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AAFD;;AAKA;EACC,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAFD;;AAKA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAFD;;AAKA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAFD;;AAKA;EACC,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAFD;;AAKA;EACC,UAAA;EACA,mBAAA;AAFD;;AAKA;EACC,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,YAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAFD;;AAKA;EACC,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,mBAAA;EACA,cAAA;AAFD;;AAKA;EACC,cAAA;EACA,mBAAA;AAFD;;AAKA;EACC,mBAAA;EACA,cAAA;AAFD;;AAKA;EACC,kBAAA;EACA,QAAA;AAFD;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,iBAAA;EACA,aAAA;AAFD;;AAKA;EACC,eAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;AAFD;;AAKA;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,aAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,sBAAA;AAFD;;AAKA;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,wBAAA;AAFD;;AAKA;EACC,uBAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,sBAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,eAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAMA;;;;;;;;;;;;;GAAA;AAeA;EACC,SAAA;AAJD;;AAOA;EACC,aAAA;AAJD;;AAOA;EACC,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAJD;;AAOA;EACC,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAJD;;AAOA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;AAJD;;AAOA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAJD;;AAOA;EACC,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAJD;;AAOA;EACC,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAJD;;AAOA;EACC,UAAA;AAJD;;AAOA;EACC,UAAA;AAJD;;AAOA;EACC,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAJD;;AAOA;EACC,YAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAJD;;AAOA;EACC,iBAAA;EACA,sBAAA;AAJD;;AAOA;EACC,iBAAA;EACA,sBAAA;AAJD;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,aAAA;EACA,eAAA;AAJD;;AAOA;EACC,UAAA;EACA,mBAAA;AAJD;;AAOA;EACC,cAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;AAJD;;AAOA;EACC,eAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAJD;;AAOA;EACC,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAJD;;AAOA;EACC,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAJD;;AAOA;EACC,eAAA;AAJD;;AAOA;EACC,WAAA;AAJD;;AAOA;EACC,UAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,wBAAA;AAJD;;AAOA;EACC,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;AAJD;;AAOA;EACC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAJD;;AAOA;EACC,uBAAA;AAJD;;AAOA;EACC,WAAA;AAJD;;AAOA;EACC,sBAAA;AAJD;;AAOA;EACC,WAAA;AAJD;;AAOA;EACC,yBAAA;AAJD;;AAOA;EACC,WAAA;AAJD;;AAOA;EACC,eAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAJD;;AAOA;EACC,WAAA;EACA,eAAA;AAJD;;AAOA;EACC,iBAAA;EACA,mBAAA;EACA,gCAAA;AAJD;;AAOA;EACC,gBAAA;AAJD;;AAOA;EACC,cAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AAJD;;AAOA;EACC,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;AAJD;;AAOA;EACC,eAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;AAJD;;AAOA;EACC,UAAA;AAJD;;AAOA;EACC,wBAAA;AAJD;;AAOA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,UAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAJD;;AAOA;EACC,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAJD;;AAOA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAJD;;AAOA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAJD;;AAOA;EACC,WAAA;EACA,yBAAA;EACA,yDAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AAJD;;AAOA;EACC,WAAA;EACA,yBAAA;EACA,yDAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;AAJD;;AAOA;EACC,yBAAA;AAJD;;AAOA;EACC,yBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,yBAAA;AAJD;;AAOA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,UAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAJD;;AAOA;EACC,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;AAJD;;AAOA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;EACA,OAAA;EACA,kBAAA;EACA,SAAA;AAJD;;AAOA;EACC,WAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,yBAAA;EACA,gCAAA;EACA,yBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,yBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,yBAAA;AAJD;;AAQA,mBAAA;AAEA;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAND;;AASA;EACC,SAAA;AAND;;AASA;EACC,WAAA;EACA,aAAA;AAND;;AASA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;AAND;;AASA;EACC,mBAAA;AAND;;AASA;EACC,wBAAA;AAND;;AASA;EACC,oBAAA;AAND;;AAUA,mBAAA;AACA;EACC,yBAAA;AAPD;;AASA;EACC,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;AAND;;AASA;EACC,mBAAA;AAND;;AASA;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AAND;;AASA;EACC,SAAA;AAND;;AASA;EACC,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAND;;AASA;EACC,iBAAA;EACA,sBAAA;AAND;;AASA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;AAND;;AASA;EACC,2BAAA;AAND;;AASA;EACC,0BAAA;AAND;;AASA;EACC,aAAA;EACA,mBAAA;EACA,wBAAA;AAND;;AASA;EACC,WAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAND;;AASA;EACC,eAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAND;;AASA;EACC,iBAAA;EACA,sBAAA;AAND;;AASA;EACC,kBAAA;AAND;;AASA;EACC,uBAAA;AAND;;AASA;EACC,gBAAA;EACA,UAAA;AAND;;AASA;EACC,uBAAA;AAND;;AASA;EACC,gBAAA;EACA,UAAA;AAND;;AASA;EACC,gBAAA;EACA,mBAAA;EACA,uBAAA;AAND;;AASA;EACC,gBAAA;EACA,mBAAA;EACA,uBAAA;AAND;;AASA;EACC,UAAA;EACA,gBAAA;AAND;;AASA;EACC,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAND;;AASA;EACC,oBAAA;AAND;;AASA;EACC,gBAAA;AAND;;AASA;EACC,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAND;;AASA;EACC,cAAA;EACA,kBAAA;AAND;;AASA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAND;;AASA;EACC,WAAA;EACA,qBAAA;EACA,mBAAA;EACA;;;sBAAA;AAHD;;AAQA,kBAAA;AACA;EACC,aAAA;AALD;;AAOC;EACC,WAAA;AAJF;;AAMC;EACC,sBAAA;AAHF;;AAKC;EACC,cAAA;EACA,kBAAA;AAFF;;AAIC;EACC,WAAA;EACA,kBAAA;EACA,UAAA;AADF;;AAGC;EACC,YAAA;EACA,MAAA;EACA,8BAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAAF;;AAGC;EACC,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AAAF;;AAEC;EACC,sBAAA;AACF;;AAEC;EACA,cAAA;AACD;;AAKC,kBAAA;AAGD,4CAAA","sourcesContent":["/* Advanced list Template styles starts  */\n\n/* .kore-chat-window .kore-chat-body {\n\tbackground: #FAFAFA !important;\n} */\n\n.kore-chat-window .advanced-list-wrapper {\n\tpadding: 10px;\n\tbackground: #ffffff;\n\t// box-shadow: inset 0px -1px 0px #eff0f1;\n\tmargin: 2px 0px;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec .left-sec {\n\twidth: 80%;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec .right-sec {\n\twidth: 20%;\n\ttext-align: right;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .content-sec .right-sec .button- {\n\tcolor: #0D6EFD;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tborder: 0;\n\toutline: 0;\n\tbackground: transparent;\n\tcursor: pointer;\n\tpadding: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin: 5px 0 0 -5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data .tag-name {\n\tbackground: #E7F1FF;\n\tborder-radius: 4px;\n\tpadding: 10px;\n\tcolor: #07377F;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tmargin: 5px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data .more-tags {\n\tpadding: 10px 15px;\n\tcolor: #0D6EFD;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.if-multiple-tags .tags-data .more-tags img {\n\tmargin-left: 10px;\n\tposition: relative;\n\ttop: 1px;\n}\n\n.kore-chat-window .advanced-list-wrapper .main-title {\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper .desc-title {\n\tcolor: #9aa0a6;\n\tletter-spacing: 0.270833px;\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 16px;\n\tmargin-top: 2px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block {\n\twidth: 40px;\n\theight: 40px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block img {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 8px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.circle-img.icon-text {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block .icon-text {\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: normal;\n\tfont-size: 12px;\n\tborder-radius: 8px;\n\tbackground: #0D6EFD;\n\tcolor: #FFFF;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.small {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.small img {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.small .icon-text {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.medium {\n\twidth: 60px;\n\theight: 60px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.medium img {\n\twidth: 60px;\n\theight: 60px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.medium .icon-text {\n\twidth: 60px;\n\theight: 60px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.large {\n\twidth: 80px;\n\theight: 80px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.large img {\n\twidth: 80px;\n\theight: 80px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.large .icon-text {\n\twidth: 80px;\n\theight: 80px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.circle-img img {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .img-block.circle-img .icon-text {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .content-block {\n\tpadding-left: 15px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .content-block.pd-0 {\n\tpadding-left: 0px !important;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-text {\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc {\n\tcolor: #9aa0a6;\n\tletter-spacing: 0.270833px;\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 16px;\n\tmargin-top: 2px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .content-block {\n\twidth: 65%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .btn_block {\n\twidth: 30%;\n}\n\n.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown {\n\ttext-align: right !important;\n\tmargin-right: 10px;\n\tpadding: 0 !important;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .btn_block .amout-text {\n\ttext-align: right;\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 20px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button .btn_block .button_ {\n\tfloat: right;\n\tborder: 0;\n\tpadding: 7px 20px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #020203;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows {\n\tflex-wrap: wrap;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .main-title-text {\n\twidth: 100%;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: #202124;\n\tmargin-bottom: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .rows-multiple-list {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 10px 0;\n\tborder-bottom: 1px solid #E4E5E7;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data {\n\tdisplay: block;\n\twidth: 100%;\n\ttext-align: right;\n\tpadding: 15px 0 8px 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data span {\n\tcursor: pointer;\n\tcolor: #0D6EFD;\n\tmargin: 0px 6px;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tdisplay: inline-block;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data .button_ {\n\tborder: 0;\n\tpadding: 7px 10px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 3px 5px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data .button_ img {\n\tposition: relative;\n\ttop: 1px;\n\tmargin-left: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-button.list-rows .see-more-data span img {\n\tposition: relative;\n\ttop: 1px;\n\tmargin-left: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion {\n\tdisplay: block;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 18px;\n\tposition: relative;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .title-main {\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tline-height: 20px;\n\twidth: 70%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .title-main.w-100 {\n\twidth: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .filter-sort-block {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 30%;\n\tjustify-content: flex-end;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .filter-sort-block .filter-icon {\n\tmargin-left: 10px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .filter-sort-block .sort-icon {\n\tmargin-left: 10px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block {\n\twidth: 30%;\n\ttext-align: right;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block .search_icon {\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block .input_text {\n\tposition: absolute;\n\tbackground-color: #fff;\n\tborder: solid 1px #BDC1C6;\n\tborder-radius: 4px;\n\theight: 34px;\n\tpadding: 10px 30px 10px 10px;\n\tfont-size: 14px;\n\tcolor: #202124;\n\tline-height: normal;\n\tmargin: 0 !important;\n\toutline: 0 !important;\n\tright: -10px;\n\twidth: 200px;\n\ttop: -6px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .search-block .close_icon {\n\tposition: absolute;\n\tright: 0;\n\tcursor: pointer;\n\ttop: 5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .if-button-mode {\n\twidth: 30%;\n\ttext-align: right;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .main-title-text-block .if-button-mode .button- {\n\tcolor: #0D6EFD;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tborder: 0;\n\toutline: 0;\n\tbackground: transparent;\n\tcursor: pointer;\n\tpadding: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper .small-title-sec {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-bottom: 10px;\n\tbox-shadow: inset 0px -1px 0px #eff0f1;\n}\n\n.kore-chat-window .advanced-list-wrapper .small-title-sec .left-title {\n\twidth: 80%;\n\tcolor: #9AA0A6;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 17px;\n}\n\n.kore-chat-window .advanced-list-wrapper .small-title-sec .right-title {\n\twidth: 20%;\n\ttext-align: right;\n\tcolor: #9AA0A6;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 20px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs .month-tab {\n\tcolor: #202124;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tmargin-right: 40px;\n\tpadding-bottom: 10px;\n\tcursor: pointer;\n\ttransition: 0.3s all ease;\n\tposition: relative;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs .month-tab:hover::after {\n\tcontent: \"\";\n\tposition: absolute;\n\twidth: 100%;\n\theight: 2px;\n\tbackground: #0D6EFD;\n\tbottom: 0;\n\tleft: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .callendar-tabs .month-tab.active-month::after {\n\tcontent: \"\";\n\tposition: absolute;\n\twidth: 100%;\n\theight: 2px;\n\tbackground: #0D6EFD;\n\tbottom: 0;\n\tleft: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top {\n\tcursor: pointer;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block {\n\twidth: 30%;\n\tpadding-right: 18px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .amout-text {\n\ttext-align: right;\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 20px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .button_ {\n\tfloat: right;\n\tborder: 0;\n\tpadding: 7px 20px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\tword-break: normal;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag {\n\tborder-radius: 4px;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tfloat: right;\n\tpadding: 2px 14px;\n\tfont-weight: normal;\n\tfont-size: 10px;\n\tline-height: 17px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag.confirm {\n\tbackground: #E7F1FF;\n\tcolor: #2F80ED;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag.shorlisted {\n\tcolor: #27AE60;\n\tbackground: #EAF6EC;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .btn_block .btn_tag.hold {\n\tbackground: #FFF1ED;\n\tcolor: #EB5757;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .action-icon-acc {\n\tposition: absolute;\n\tright: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-header-top .action-icon-acc.rotate-icon {\n\ttransform: rotate(180deg);\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content {\n\tpadding-top: 14px;\n\tdisplay: none;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .button-header {\n\tfont-size: 12px;\n\tcolor: #5F6368;\n\tborder-top: 1px solid #E4E5E7;\n\tmargin-top: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .button-header .button-header-title {\n\tmargin-top: 5px;\n\tmargin-left: 5px;\n\tfont-weight: 500;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tmargin: 5px 0;\n\tpadding: 5px 10px 0 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content .icon-img {\n\twidth: 25px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content .icon-img img {\n\tvertical-align: middle;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content .text-info {\n\tpadding-left: 0;\n\tcolor: #5f6368 !important;\n\tletter-spacing: 0.3px;\n\tfont-weight: 500;\n\tfont-size: 12px;\n\tline-height: 19px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 10px -5px 0 -5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-center {\n\tjustify-content: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-center .button_ {\n\twidth: auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-left {\n\tjustify-content: start;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-left .button_ {\n\twidth: auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-right {\n\tjustify-content: flex-end;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-btn-position-right .button_ {\n\twidth: auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-full-width-btn {\n\tflex-wrap: wrap;\n\twidth: 100%;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tposition: relative;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc.if-full-width-btn .button_ {\n\twidth: 100%;\n}\n\n\n/* .kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info{\n    list-style: none;\n    display: none;\n    position: absolute;\n    padding: 10px;\n    right: 10px;\n    max-height: 200px;\n    box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n    border-radius: 5px;\n    background: #fff;\n    height: auto;\n    min-height: auto;\n    z-index: 99;\n} */\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info li {\n\tmargin: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info li .button_ {\n\tmargin: 5px 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ {\n\tborder: 0;\n\tpadding: 7px 10px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 3px 5px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .more-btn {\n\tborder: 0;\n\tpadding: 7px 10px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 3px 5px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info .close_btn {\n\tcursor: pointer;\n\tborder: none;\n\toutline: none;\n\tposition: static !important;\n\t/* top: 5px; */\n\tright: 22px;\n\tbackground: #fff;\n\tborder-radius: 100%;\n\tpadding: 0;\n\twidth: 25px;\n\theight: 25px;\n\ttext-align: center;\n\tz-index: 2;\n\ttransition: 0.3s all ease;\n\tfloat: right;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .more-button-info .close_btn:hover {\n\tbackground: #DFE7F5;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper {\n\tpadding: 10px;\n\tbackground: #ffffff;\n\tbox-shadow: inset 0px -1px 0px #eff0f1;\n\tmargin: 2px 0px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper .main-title {\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper .desc-title {\n\tcolor: #9aa0a6;\n\tletter-spacing: 0.270833px;\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 16px;\n\tmargin-top: 2px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block {\n\twidth: 40px;\n\theight: 40px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block img {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 8px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block .icon-text {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 8px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block.circle-img img {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .img-block.circle-img .icon-text {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .content-block {\n\tpadding-left: 15px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .content-block .title-text {\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title .content-block .title-desc {\n\tcolor: #9aa0a6;\n\tletter-spacing: 0.270833px;\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 16px;\n\tmargin-top: 2px;\n\tword-break: break-word;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .content-block {\n\twidth: 65%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .btn_block {\n\twidth: 30%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .btn_block .amout-text {\n\ttext-align: right;\n\tcolor: #202124;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 20px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ .advanced-list-wrapper.img-with-title.with-button .btn_block .button_ {\n\tfloat: right;\n\tborder: 0;\n\tpadding: 7px 20px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .button_ img {\n\tmargin-right: 6px;\n\tvertical-align: middle;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-btns-acc .more-btn img {\n\tmargin-right: 6px;\n\tvertical-align: middle;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec {\n\tpadding-left: 50px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table {\n\twidth: 33%;\n\tmargin-bottom: 15px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table-more {\n\tdisplay: block;\n\twidth: 100%;\n\ttext-align: right;\n\tpadding: 10px 0 8px 0;\n\tmargin-right: 30px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table-more span img {\n\tposition: relative;\n\ttop: 1px;\n\tmargin-left: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table-more span {\n\tcursor: pointer;\n\tcolor: #0D6EFD;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tdisplay: inline-block;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table .header-name {\n\tcolor: #9AA0A6;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tmargin: 4px 0px;\n\tpadding: 0 5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec .column-table .title-name {\n\tcolor: #202124;\n\tletter-spacing: 0.270833px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tmargin: 4px 0px;\n\tpadding: 0 5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns {\n\tmargin: 0 -10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table.full-row {\n\twidth: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table {\n\twidth: 50%;\n\tmargin-bottom: 15px;\n\tpadding: 0 10px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.rounded-img {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.rounded-img img {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block {\n\twidth: 30px;\n\theight: 30px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block img {\n\twidth: 30px;\n\theight: 30px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.small {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.small img {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.medium {\n\twidth: 40px;\n\theight: 40px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.medium img {\n\twidth: 40px;\n\theight: 40px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.large {\n\twidth: 60px;\n\theight: 60px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.large img {\n\twidth: 60px;\n\theight: 60px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.extralarge {\n\twidth: 80px;\n\theight: 80px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .labeld-img-block.extralarge img {\n\twidth: 80px;\n\theight: 80px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .inner-acc-table-sec .table-sec.if-label-table-columns .column-table .label-content {\n\tpadding-left: 15px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 10px -5px 0 -5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group .p-button {\n\tborder: 0;\n\tpadding: 7px 20px;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\tbackground: #0D6EFD;\n\tborder-radius: 4px;\n\tcolor: #FFFFFF;\n\twidth: 100%;\n\tmargin: 0 5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group .s-button {\n\tpadding: 7px 20px;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 0 5px;\n\tbackground: #FFFFFF;\n\tborder: 1px solid #BDC1C6;\n\tbox-sizing: border-box;\n\tborder-radius: 4px;\n\tcolor: #202124;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-center {\n\tjustify-content: center;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-center button {\n\twidth: auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-left {\n\tjustify-content: start;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-left button {\n\twidth: auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-right {\n\tjustify-content: flex-end;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-btn-position-right button {\n\twidth: auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-full-width-btn {\n\tflex-wrap: wrap;\n\twidth: 100%;\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .btn_group.if-full-width-btn button {\n\twidth: 100%;\n\tmargin-top: 5px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows {\n\tmargin: 8px 0 0 0;\n\tpadding-bottom: 8px;\n\tborder-bottom: 1px solid #E4E5E7;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows :last-child{\n\tborder-bottom: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data {\n\tdisplay: block;\n\twidth: 100%;\n\ttext-align: right;\n\tpadding: 15px 0 8px 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data .button_seemore {\n\tborder: 0;\n\tpadding: 7px 10px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 3px 5px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data .button_ img {\n\tposition: relative;\n\ttop: 1px;\n\tmargin-left: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data span {\n\tcursor: pointer;\n\tcolor: #0D6EFD;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tdisplay: inline-block;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data span img {\n\tposition: relative;\n\ttop: 1px;\n\tmargin-left: 10px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .accor-header-top .content-block {\n\twidth: 65%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .accor-header-top .action-icon-acc.rotate-icon {\n\ttransform: rotate(90deg);\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox {\n\tdisplay: block;\n\tpadding: 11px 10px;\n\tposition: relative;\n\tborder-radius: 4px;\n\tmargin: 4px 0px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox.selected-item {\n\tbackground: #E7F1FF;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox.selected-item .checkbox-custom+.checkbox-custom-label {\n\tcolor: #202124;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom {\n\topacity: 0;\n\tposition: absolute;\n\tcursor: pointer;\n\tmargin: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom+.checkbox-custom-label {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tcursor: pointer;\n\tposition: relative;\n\tmargin: 0;\n\tpadding-left: 32px;\n\tcolor: #9AA0A6;\n\tletter-spacing: 0.270833px;\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom+.checkbox-custom-label::before {\n\tcontent: '';\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: 18px;\n\theight: 18px;\n\tpadding: 0;\n\ttext-align: center;\n\tborder-radius: 2px;\n\tborder: solid 1px #BDC1C6;\n\tbackground-color: #fff;\n\tposition: absolute;\n\tleft: 0;\n\ttop: -2px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom+.checkbox-custom-label::after {\n\tcontent: '';\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: 18px;\n\theight: 18px;\n\tpadding: 0;\n\ttext-align: center;\n\tborder-radius: 2px;\n\tborder: solid 1px #BDC1C6;\n\tbackground-color: #fff;\n\tposition: absolute;\n\tleft: 0;\n\ttop: -2px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:checked+.checkbox-custom-label::before {\n\tcontent: \"\";\n\tbackground-color: #0D6EFD;\n\tbackground-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDE2IDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTMuMiAoNzI2NDMpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPg0KICAgIDx0aXRsZT5jaGVjay13aGl0ZTwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJjaGVjay13aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyI+DQogICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbC1vcGFjaXR5PSIwIiBmaWxsPSIjRDhEOEQ4IiBwb2ludHM9IjAgMCAxNiAwIDE2IDE2IDAgMTYiPjwvcG9seWdvbj4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNC4yLDIuODM1IEMxNC40LDIuNjIgMTQuNzMzLDIuNjEgMTQuOTQ1LDIuODExIEMxNS4xNDUsMyAxNS4xNjUsMy4zMDkgMTUuMDAyLDMuNTIzIEwxNC45NjksMy41NjMgTDYuMDQ5LDEzLjE2NSBDNS44NTksMTMuMzcgNS41NDUsMTMuMzg5IDUuMzMzLDEzLjIxNSBMNS4yOTUsMTMuMTggTDEuMDQ1LDguOTUzIEMwLjg0LDguNzQ3IDAuODM3LDguNDEgMS4wNCw4LjIgQzEuMjMzLDguMDAzIDEuNTQsNy45ODkgMS43NDgsOC4xNiBMMS43ODUsOC4xOTQgTDUuNjUsMTIuMDQgTDE0LjIsMi44MzUgWiIgaWQ9IlBhdGgiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');\n\tcolor: #fff;\n\tfont-size: 12px;\n\tbackground-size: 14px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tborder: solid 1px #0D6EFD;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:checked+.checkbox-custom-label::after {\n\tcontent: \"\";\n\tbackground-color: #0D6EFD;\n\tbackground-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDE2IDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTMuMiAoNzI2NDMpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPg0KICAgIDx0aXRsZT5jaGVjay13aGl0ZTwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJjaGVjay13aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyI+DQogICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbC1vcGFjaXR5PSIwIiBmaWxsPSIjRDhEOEQ4IiBwb2ludHM9IjAgMCAxNiAwIDE2IDE2IDAgMTYiPjwvcG9seWdvbj4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNC4yLDIuODM1IEMxNC40LDIuNjIgMTQuNzMzLDIuNjEgMTQuOTQ1LDIuODExIEMxNS4xNDUsMyAxNS4xNjUsMy4zMDkgMTUuMDAyLDMuNTIzIEwxNC45NjksMy41NjMgTDYuMDQ5LDEzLjE2NSBDNS44NTksMTMuMzcgNS41NDUsMTMuMzg5IDUuMzMzLDEzLjIxNSBMNS4yOTUsMTMuMTggTDEuMDQ1LDguOTUzIEMwLjg0LDguNzQ3IDAuODM3LDguNDEgMS4wNCw4LjIgQzEuMjMzLDguMDAzIDEuNTQsNy45ODkgMS43NDgsOC4xNiBMMS43ODUsOC4xOTQgTDUuNjUsMTIuMDQgTDE0LjIsMi44MzUgWiIgaWQ9IlBhdGgiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');\n\tcolor: #fff;\n\tfont-size: 12px;\n\tbackground-size: 14px;\n\tbackground-repeat: no-repeat;\n\tborder: solid 1px #0D6EFD;\n\tbackground-position: center;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:checked:disabled+.checkbox-custom-label::before {\n\tbackground-color: #a6dce1;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:disabled+.checkbox-custom-label::before {\n\tborder: solid 1px #BDC1C6;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:focus+.checkbox-custom-label {\n\tcolor: #0D6EFD;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_checkbox .checkbox-custom:focus+.checkbox-custom-label::before {\n\tborder: 1px solid #1372ff;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton {\n\tdisplay: block;\n\tpadding: 11px 10px;\n\tposition: relative;\n\tborder-radius: 4px;\n\tmargin: 4px 0px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton.selected-item {\n\tbackground: #E7F1FF;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton.selected-item .radio-custom+.radio-custom-label {\n\tcolor: #202124;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom {\n\topacity: 0;\n\tposition: absolute;\n\tcursor: pointer;\n\tmargin: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom+.radio-custom-label {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tcursor: pointer;\n\tposition: relative;\n\tcolor: #9AA0A6;\n\tmargin: 0;\n\tfont-weight: normal;\n\tpadding-left: 32px;\n\tletter-spacing: 0.270833px;\n\tfont-size: 13px;\n\tline-height: 16px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom+.radio-custom-label::before {\n\tcontent: '';\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: 18px;\n\theight: 18px;\n\tpadding: 0;\n\tmargin-right: 12px;\n\ttext-align: center;\n\tborder: solid 1px #BDC1C6;\n\tbackground-color: #fff;\n\tmargin-top: 0;\n\tborder-radius: 100px;\n\tleft: 0;\n\tposition: absolute;\n\ttop: -2px;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked+.radio-custom-label::before {\n\tcontent: \"\";\n\tcolor: #fff;\n\tfont-size: 12px;\n\tbackground-color: #0D6EFD;\n\tborder: 1px solid #0D6EFD;\n\tbox-shadow: inset 0 0 0 4px #fff;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked:focus+.radio-custom-label {\n\tcolor: #0D6EFD;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked:disabled+.radio-custom-label {\n\tcolor: #dde1e7;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:checked:disabled+.radio-custom-label::before {\n\tborder: solid 1px #a6dce1;\n\tbox-shadow: inset 0 0 0 4px #fff;\n\tbackground-color: #a6dce1;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:disabled+.radio-custom-label {\n\tcolor: #dde1e7;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:disabled+.radio-custom-label::before {\n\tborder: solid 1px #a6dce1;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:focus+.radio-custom-label {\n\tcolor: #0D6EFD;\n}\n\n.kore-chat-window .advanced-list-wrapper .kr_sg_radiobutton .radio-custom:focus+.radio-custom-label::before {\n\tborder: 1px solid #0D6EFD;\n}\n\n\n/* dropdown styles*/\n\n.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info {\n\tlist-style: none;\n\tdisplay: none;\n\tposition: absolute;\n\tpadding: 10px;\n\tright: 10px;\n\tmax-height: 200px;\n\tbox-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n\tborder-radius: 5px;\n\tbackground: #fff;\n\theight: auto;\n\tmin-height: auto;\n\tz-index: 99;\n}\n\n.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info li {\n\tmargin: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info li .button_ {\n\twidth: 100%;\n\tmargin: 5px 0;\n}\n\n.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info .close_btn {\n\tcursor: pointer;\n\tborder: none;\n\toutline: none;\n\tposition: static !important;\n\t/* top: 5px; */\n\tright: 22px;\n\tbackground: #fff;\n\tborder-radius: 100%;\n\tpadding: 0;\n\twidth: 25px;\n\theight: 25px;\n\ttext-align: center;\n\tz-index: 2;\n\ttransition: 0.3s all ease;\n\tfloat: right;\n}\n\n.kore-chat-window .advanced-list-wrapper .accor-header-top .btn_block.dropdown .more-button-info .close_btn:hover {\n\tbackground: #DFE7F5;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .see-more-data.hide {\n\tdisplay: none !important;\n}\n\n.kore-chat-window .advanced-list-wrapper.fromHistory {\n\tpointer-events: none;\n}\n\n\n/* slider actions */\n.kore-chat-window .kore-action-sheet{\n\tdisplay: block !important;\n}\n.kore-chat-window .kore-action-sheet .advanced-list-wrapper {\n\t/* height:462px; */\n\toverflow-y: auto;\n\tanimation-name: fadeInBottom;\n\tanimation-duration: 1s;\n\tanimation-fill-mode: both;\n\theight: 400px !important;\n\tpadding: 15px;\n\tmargin-top: 30px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info .close_btn:hover {\n\tbackground: #DFE7F5;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info {\n\tlist-style: none;\n\tdisplay: none;\n\tposition: absolute;\n\tpadding: 10px;\n\tright: 10px;\n\tmax-height: 200px;\n\tbox-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n\tborder-radius: 5px;\n\tbackground: #fff;\n\theight: auto;\n\tmin-height: auto;\n\tz-index: 99;\n\twidth:auto;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info li {\n\tmargin: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info li .button_ {\n\tmargin: 5px 0;\n\tborder: 0;\n\tpadding: 7px 10px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 3px 5px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info li .button_ img {\n\tmargin-right: 6px;\n\tvertical-align: middle;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .more-button-info .close_btn {\n\tcursor: pointer;\n\tborder: none;\n\toutline: none;\n\tposition: static !important;\n\t/* top: 5px; */\n\tright: 22px;\n\tbackground: #fff;\n\tborder-radius: 100%;\n\tpadding: 0;\n\twidth: 25px;\n\theight: 25px;\n\ttext-align: center;\n\tz-index: 2;\n\ttransition: 0.3s all ease;\n\tfloat: right;\n}\n\n.kore-chat-window .kore-action-sheet .advanced-list-wrapper .main-title-text-block {\n\tmargin-top: 20px !important;\n}\n\n.pl-0 {\n\tpadding-left: 0 !important;\n}\n\n.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 10px -5px 0 -5px;\n}\n\n.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc .button_ {\n\twidth: auto;\n\tborder: 0;\n\tpadding: 7px 10px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #07377f;\n\tfont-weight: normal;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n\tmargin: 3px 5px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n\n.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc.if-full-width-btn {\n\tflex-wrap: wrap;\n\twidth: 100%;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tpadding: 15px;\n}\n\n.kore-action-sheet .advancelisttemplate .TaskPickerContainer .inner-btns-acc .button_ img {\n\tmargin-right: 6px;\n\tvertical-align: middle;\n}\n\n.kore-action-sheet .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows {\n\tposition: relative;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top {\n\talign-items: flex-start;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block {\n\tpadding-top: 3px;\n\twidth: 57%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top {\n\talign-items: flex-start;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block {\n\tpadding-top: 3px;\n\twidth: 53%;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block .title-text {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .content-block .title-desc {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .btn_block {\n\twidth: 40%;\n\tpadding-right: 0;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-header-top .btn_block .amout-text {\n\tfont-weight: normal;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tcolor: #9AA0A6;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type {\n\tpointer-events: none;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-inner-content {\n\tpadding-top: 0px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows.if-template-view-type .accor-inner-content .details-content.if-icon-right .text-info {\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #202124;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content.if-icon-right {\n\tdisplay: block;\n\tposition: relative;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content.if-icon-right .icon-img {\n\twidth: auto;\n\tposition: absolute;\n\tright: 4px;\n\ttop: 9px;\n}\n\n.kore-chat-window .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content .details-content.if-icon-right .text-info {\n\twidth: 100%;\n\tdisplay: inline-block;\n\tpadding-right: 10px;\n\t/* font-weight: normal;\n    font-size: 14px;\n    line-height: 20px;\n    color: #202124; */\n}\n/* advanced list */\n.kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon{\n\tdisplay: flex;\n }\n .kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon .desc-icon{\n\t width: 25px;\n }\n .kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon .img{\n\t vertical-align: middle;\n }\n .kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon.if-icon-right{\n\t display: block;\n\t position: relative;\n }\n .kore-chat-window .advanced-list-wrapper.img-with-title .content-block .title-desc.desciptionIcon.if-icon-right .desc-icon{\n\t width: auto;\n\t position: absolute;\n\t right: 4px;\n }\n .kore-chat-window .advanced-list-wrapper .preview-modal-header {\n\t height: 54px;\n\t top: 0;\n\t margin: -10px -10px 10px -10px;\n\t background: #FFFFFF;\n\t box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n\t border-radius: 4px;\n\t padding: 20px;\n\t font-weight: normal;\n\t font-size: 16px;\n\t line-height: 14px;\n\t display: flex;\n\t align-items: center;\n\t justify-content: space-between;\n\t color: #202124;\n }\n \n .kore-chat-window .advanced-list-wrapper .preview-modal-header .advancedlist-template-close {\n\t cursor: pointer;\n\t background: none;\n\t border: none;\n\t outline: none;\n\t position: relative;\n\t top: 0;\n\t right: 0;\n\t padding: 0;\n }\n .kore-chat-window .advanced-list-wrapper.img-with-title .content-block.w-100{\n\t width:100% !important;\n }\n\n .advanced-list-wrapper.img-with-title.with-accordion .accor-inner-content.displayBlock {\n\tdisplay: block;\n}\n// .advanced-list-wrapper.img-with-title.with-accordion.if-multiple-accordions-list .multiple-accor-rows:last-child{\n// \tborder: none !important;\n// \tpadding-bottom: 0;\n// }\n /* advanced-list */\n\n\n/* advanced list template styles ends here */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
